import axios from 'axios';
import {AuthCredentials} from '@/store/modules/auth';

export default class Auth {
  login(credentials: AuthCredentials) {
    return axios.post('/auth/login', credentials);
  }

  me() {
    return axios.get('/auth/role-menu?type=web');
  }

  register(payload = {}) {
    return axios.post('/auth/register', payload);
  }

  registerMail(payload = {}) {
    return axios.post('/mail/send', payload);
  }

  changePassword(data: object) {
    return axios.post('/auth/change-password', data);
  }

  getLinkresetPassword(data: object) {
    return axios.post('/auth/getLink-reset-password', data);
  }

  resetPassword(data: object) {
    return axios.post('/auth/reset-password', data);
  }

  checkVerification(params = {}) {
    return axios.get('/mail/verify', {params});
  }
}
